import { IAvailableSeasonTicket } from '@r1-frontend/api-domru/api-season-ticket/v1/season-ticket/dto/ResponseDto';

import { RubleSymbol } from '@r1-frontend/ui-react/experimental/purchase/cost/Cost/RubleSymbol';
import ToggleCard from '@r1-frontend/ui-react/organisms/ToggleCard';
import { TInfoBlockData } from '@r1-frontend/ui-react/organisms/ToggleCard/types';
import { pluralize } from '@r1-frontend/shared/helpers/pluralize';
import { monthPluralize } from '@r1-frontend/shared/helpers/pluralize/predifined';

import { toCurrency } from '~/src/helpers/numbers';

interface IProps {
    isActive: boolean,
    ticket: IAvailableSeasonTicket,
    onSelect: (id: TInfoBlockData['id']) => void,
}

const SeasonTicket = ({ isActive, ticket, onSelect }: IProps): JSX.Element => {
    const { id, countMonth, deltaPeriod, sumPrice } = ticket;

    const totalDiscount = `${toCurrency(deltaPeriod)} ${RubleSymbol}`;

    const cardData: TInfoBlockData = {
        id,
        title: `${countMonth} ${pluralize(countMonth, monthPluralize)}`,
        info: `Экономия – ${totalDiscount}`,
        price: toCurrency(sumPrice),
    };

    return (
        <ToggleCard
            isActive={isActive}
            type={cardData}
            onToggleType={onSelect}
        />
    );
};

export default SeasonTicket;
